import axios from "axios";
import { logout } from "../Actions/Auth";
import { setAlert } from '../Actions/Alert';
import  store  from '../store';

//deployment
const axiosAuth = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
    'Content-Type': 'application/json'
  }
});

axiosAuth.interceptors.request.use(
    config => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['x-auth-token'] = token;
      }
      const guestToken = localStorage.getItem('guestToken');
      if (guestToken) {
        config.headers['x-guest-token'] = guestToken;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  axiosAuth.interceptors.response.use(
    (response) => response,
    error => {
        if (error.response && error.response.status === 401){
          actionInvalidToken();
            
        }
        return Promise.reject(error);
    }
)

const actionInvalidToken = () => {

  store.dispatch(setAlert("New Updates Available. You will be logged out in a few seconds","401"))
 
  setTimeout(() => {
    logout();
    window.location.href = "/"
    // console.log("response", error.response)
    console.log("Invalid token logout")
  }, 2000)

  // alert("New update available. You will be logged out in a few seconds")
}

export default axiosAuth;